<template>
  <div>
    <v-row justify="space-between" align="center">
      <v-col md="4" cols="12">
        <v-text-field
          v-model="filter.q"
          placeholder="Cari nomor, kode atau tujuan surat"
          prepend-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col md="3" cols="12" v-if="hasPrivateAccess">
        <v-autocomplete
          class="mt-3"
          prepend-icon="mdi-account"
          label="Pengolah"
          v-model="filter.bidang_id"
          item-value="id"
          item-text="name"
          :items="$store.state.bidang"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col md="2" cols="12">
        <datepicker
          v-model="filter.dates"
          range
          placeholder="Tanggal Surat Keluar"
          :shortcuts="datePickerShortcut"
          format="DD/MM/YYYY"
        />
      </v-col>
      <v-col md="2" cols="12" v-if="hasPrivateAccess">
        <v-checkbox
          v-model="filter.no_attachment"
          color="red"
          label="Tanpa Arsip"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="no"
      :loading="loading"
      :sort-by.sync="filter.order_by"
      :sort-desc.sync="filter.sort_desc"
      hide-default-footer
    >
      <template v-slot:[`item.tgl_surat`]="{ item }">
        <div class="oflow">{{ item.tgl_surat | date }}</div>
      </template>
      <template v-slot:[`item.lampiran`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              light
              @click="item.lampiran ? viewArsip(item.lampiran) : null"
              :color="item.lampiran ? 'success' : 'grey'"
            >
              <v-icon>{{
                item.lampiran ? 'mdi-file-document-outline' : 'mdi-file-remove'
              }}</v-icon>
            </v-btn>
          </template>
          <span>{{
            item.lampiran ? 'Cetak arsip' : 'Arsip belum diupload'
          }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="row-column">
          <v-tooltip
            bottom
            v-if="item.nama_bidang && item.kode && hasPrivateAccess"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                light
                color="primary"
                @click="onViewReceipt(item)"
              >
                <v-icon>mdi-receipt</v-icon>
              </v-btn>
            </template>
            <span>Kartu Surat Keluar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="hasPrivateAccess">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                light
                @click="onEditItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isSuperAdmin">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                light
                color="error"
                @click="onDeleteBtnPressed(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Hapus Surat</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <v-pagination
      v-model="pagination.current_page"
      :length="pagination.last_page"
      :total-visible="7"
    />
    <v-dialog v-model="dialog">
      <view-surat
        ref="viewSurat"
        :id-jenis-form="2"
        :texts="selectedItem"
        @close-view-form="dialog = false"
      />
    </v-dialog>
    <v-dialog
      v-model="deleteDialogVisible"
      transition="dialog-bottom-transition"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          Yakin Hapus Surat Keluar?
        </v-card-title>

        <v-card-text>
          <table class="delete-table">
            <tr>
              <td>No. Surat</td>
              <th>: {{ deleteSurat.index_surat_tu }}</th>
            </tr>
            <tr>
              <td>Klasifikasi</td>
              <th>: {{ deleteSurat.jenis_surat }}</th>
            </tr>
            <tr>
              <td>Pengolah</td>
              <th>: {{ deleteSurat.nama_bidang }}</th>
            </tr>
            <tr>
              <td>Tujuan</td>
              <th>: {{ deleteSurat.tujuan }}</th>
            </tr>
            <tr>
              <td>Perihal</td>
              <th>: {{ deleteSurat.perihal }}</th>
            </tr>
          </table>

          <v-alert text dense color="warning">
            Data surat tidak dapat dikembalikan setelah dihapus
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            @click="deleteDialogVisible = false"
            :disabled="deleting"
          >
            Tidak
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="onDeleteConfirmed"
            :loading="deleting"
          >
            Ya, Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  headerSuratKeluar,
  fetchSuratKeluar,
  deleteSuratKeluar
} from '@/services/surat'
import ViewSurat from '@/components/ViewSurat.vue'
import { debounce } from 'lodash'
import { mapGetters } from 'vuex'
import { shortcut } from '@/utils/date-picker'
import moment from 'moment'
import { createkartuSuratKeluar } from '@/utils/common'

export default {
  name: 'surat-keluar-list',
  components: {
    'view-surat': ViewSurat
  },
  data() {
    return {
      selectedItem: {},
      dialog: false,
      loading: false,
      headers: headerSuratKeluar,
      isEdit: false,
      items: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        from: 1,
        total: 0,
        last_page: 1
      },
      filter: {
        no_attachment: false,
        q: '',
        order_by: [],
        sort_desc: [true],
        dates: [],
        bidang_id: null
      },
      deleteDialogVisible: false,
      deleteSurat: {},
      deleting: false,
      datePickerShortcut: shortcut
    }
  },
  computed: {
    ...mapGetters(['hasPrivateAccess', 'isSuperAdmin']),
    currentPage() {
      return this.pagination.current_page
    }
  },
  watch: {
    currentPage: function(val) {
      this.loadData(val)
    },
    filter: {
      handler: debounce(function() {
        this.loadData(1)
      }, 500),
      deep: true
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    onViewReceipt(item) {
      console.log('cetak kartu', item)
      createkartuSuratKeluar(item)
    },
    async loadData(page = 1) {
      this.loading = true
      try {
        const {
          no_attachment,
          dates,
          order_by,
          sort_desc,
          ...filter
        } = this.filter
        let params = {
          ...filter,
          page,
          per_page: this.pagination.per_page
        }
        if (dates.length && dates[0]) {
          params.from = moment(dates[0]).format('YYYY-MM-DD')
          params.to = moment(dates[1]).format('YYYY-MM-DD')
        }
        if (order_by.length) {
          params.order_by = order_by[0]
        }
        if (sort_desc.length) {
          params.sort = sort_desc[0] ? 'desc' : 'asc'
        }
        if (no_attachment) {
          params.no_attachment = true
        }

        const { data, pagination } = await fetchSuratKeluar(params)
        this.items = data
        this.pagination = pagination
      } catch (error) {
        // console.log(error)
      } finally {
        this.loading = false
      }
    },
    getRowOrderNumber(item) {
      const index = this.items.findIndex(i => i.id === item.id)
      return this.pagination.from + index
    },
    onEditItem(item) {
      item.selectedItemTableIndex = this.items.indexOf(item)
      this.isEdit = true
      this.$emit('edit-surat', { ...item })
    },
    onDeleteBtnPressed(item) {
      this.deleteDialogVisible = true
      this.deleteSurat = item
    },
    async onDeleteConfirmed() {
      this.deleting = true
      try {
        await deleteSuratKeluar(this.deleteSurat.id)
        this.deleteDialogVisible = false
        this.deleting = false
        this.deleteSurat = {}
        this.$emit('handle-snackbar', 'Surat keluar telah dihapus', 'success')
        this.loadData(this.pagination.current_page)
      } catch (error) {
        this.deleting = false
        this.$emit(
          'handle-snackbar',
          'Tidak dapat menghapus surat keluar',
          'error'
        )
      }
    },
    viewArsip(url) {
      if (!url) {
        return
      }
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
.row-column
  display: flex
  flex-direction: row
  justify-content: flex-end
  align-items: center
.delete-table
  width: 100%
  margin-bottom: 20px
  th
    text-align: left
</style>
